import { useState, useEffect, useRef } from 'react'
import { PerformanceMetrics } from '@/types/settings'

export const usePerformanceMonitoring = (isActive: boolean) => {
  const [performanceMetrics, setPerformanceMetrics] = useState<PerformanceMetrics>({
    renderTime: 0,
    memoryUsage: 0,
    fps: 60
  })
  const renderStartTime = useRef<number>(0)

  useEffect(() => {
    if (!isActive) return

    const startTime = performance.now()
    renderStartTime.current = startTime

    const measurePerformance = () => {
      const renderTime = performance.now() - startTime
      const memoryInfo = (performance as any).memory
      const memory = memoryInfo?.usedJSHeapSize || memoryInfo?.totalJSHeapSize || 0
      setPerformanceMetrics(prev => ({
        renderTime: Math.round(renderTime),
        memoryUsage: Math.round(memory / 1024 / 1024),
        fps: Math.max(1, Math.round(1000 / Math.max(renderTime, 1)))
      }))
    }

    const timeoutId = setTimeout(measurePerformance, 16) // Next frame
    return () => clearTimeout(timeoutId)
  }, [isActive])

  return performanceMetrics
}